// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import fa from './locales/fa.json';
import errorsFa from './locales/errors-fa.json';
import errorsEn from './locales/errors-en.json';
import Config from './config';

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: { ...en, errors: errorsEn } },
      fa: { translation: { ...fa, errors: errorsFa } }
    },
    fallbackLng: Config.defaultLanguage || 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
